import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import "./Register.css";
import {
  Form,
  Input,
  Button,
  Col,
  Row,
  Select,
  DatePicker,
  Slider,
  Modal,
  Progress,
  Alert,
} from "antd";
import {
  sendOtp,
  verifyOtp,
  registerData,
  sendImagesToModel,
} from "../../components/service/fhirAPI";
import moment from "moment";
import userImg from "../../assets/user.png";
import Webcam from "react-webcam";
import { useNavigate } from "react-router-dom";

const { TextArea } = Input;
const Register = () => {
  const aadharRegex = /^[1-9]\d{11}$/;
  const aadharNoRef = useRef();
  const otpRef = useRef();
  const [loading, setloading] = useState(false);
  const [error, setError] = useState(null);
  const [isOtp, setisOtp] = useState(false);
  const [refId, setrefId] = useState("");
  const [aadharData, setAadharData] = useState(null);
  const [photo, setPhoto] = useState();
  const webcamRef = useRef(null);
  const [capturedImages, setCapturedImages] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [progress, setProgress] = useState(0);
  const [uid, setUid] = useState(null);
  const webcamInitialized = useRef(false);
  useEffect(() => {
    let intervalId;

    if (capturedImages.length < 15 && webcamInitialized.current) {
      intervalId = setInterval(captureImage, 1000);
    }

    return () => {
      clearInterval(intervalId);
    };
  }, [capturedImages.length, uid]);

  useEffect(() => {
    webcamInitialized.current = true;
  }, []);

  const openModal = () => {
    setIsModalVisible(true);
  };

  const closeModal = () => {
    setIsModalVisible(false);
    setCapturedImages([]);
    setProgress(0);
    webcamInitialized.current = false; // Reset webcamInitialized to false when modal is closed
  };

  const captureImage = () => {
    if (webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot();
      const base64Image = imageSrc?.split(",")[1]; // Extract base64 string from data URL
      if (base64Image) {
        setCapturedImages((prevImages) => [...prevImages, base64Image]);
        setProgress((prevProgress) => Math.ceil(prevProgress + 100 / 14));
      }
    }
  };
  const [form] = Form.useForm();
  const onFinish = useCallback(
    async (values) => {
      console.log(values);
      form.resetFields();
      const res = await registerData({
        ...values,
        aadharno: aadharNoRef.current.value,
        address1: "",
        country1: "",
        dob: values.dob._i || "",
        housename1: "",
        phone1: "",
        pincode1: "",
        postoffice1: "",
        state1: "",
        type: "patient",
      });
      if (!res.userId) {
        alert("Something went wrong");
        return;
      }
      setUid(res.userId);
      openModal();
      aadharNoRef.current.value = "";
    },
    [form]
  );

  const onFinishFailed = (errorInfo) => {
    console.log("Form submission failed:", errorInfo);
  };
  const navigate = useNavigate();
  const formAutoData = useMemo(() => {
    return {
      aadharno: aadharNoRef?.current?.value || "",
      address: aadharData?.split_address?.street || "",
      address1: "",
      age: "",
      bloodgroup: "",
      cast: "",
      category: "",
      cellphone: "",
      city: aadharData?.split_address?.vtc || "",
      country: aadharData?.split_address?.country || "",
      country1: "",
      dob:
        aadharData?.dob !== undefined
          ? moment(aadharData?.dob, "DD-MM-YYYY")
          : "",
      email: "",
      fathername: aadharData?.care_of || "",
      firstname: aadharData?.firstname || "",
      housename: aadharData?.split_address?.house || "",
      housename1: "",
      income: ["5000", "10000"],
      initial: "",
      lastname: aadharData?.lastname || "",
      maritalstatus: "",
      middlename: "",
      nationality: "",
      occupation: "",
      officephone: "",
      phone: "",
      phone1: "",
      pincode: aadharData?.split_address?.pincode || "",
      pincode1: "",
      postoffice: aadharData?.split_address?.po || "",
      postoffice1: "",
      registrationtype: "",
      religion: "",
      remarks: "",
      sex:
        aadharData?.gender !== undefined
          ? aadharData?.gender === "M"
            ? "male"
            : "female"
          : "male",
      state: aadharData?.split_address?.state || "",
      state1: "",
      title: "",
      type: "patient",
      yearsmonth: "Years",
    };
  }, [aadharData]);

  useEffect(() => {
    form.setFieldsValue(formAutoData);
  }, [form, formAutoData]);

  useEffect(() => {
    var aadharPhoto = "data:image/jpeg;base64," + aadharData?.photo_link;
    setPhoto(aadharPhoto);
  }, [aadharData]);

  const handleAdhar = async () => {
    const aadharNoValue = aadharNoRef.current.value;
    if (!aadharRegex.test(aadharNoValue)) {
      setError("Invalid aadhar number");

      return;
    }
    if (aadharNoValue) {
      setloading(true);
    }

    const res = await sendOtp(aadharNoValue);
    if (res.error) {
      setError(res.message);
      setloading(false);
      aadharNoValue.current.value = "";
    }
    if (res.status === "INVALID") {
      setError("Invalid Aadhar Number");
      aadharNoRef.current.value = "";
      setloading(false);
      return;
    }
    if (res.status === "SUCCESS") {
      setisOtp(true);
      aadharNoRef.current.value = "";
      setrefId(res.ref_id);
      setloading(false);
    }
  };

  const handleOtpVerification = async () => {
    const enteredOtp = otpRef.current.value;
    if (enteredOtp <= 6) {
      setError("Invalid Otp");
      return;
    }
    if (enteredOtp) {
      setloading(true);
    }
    try {
      const res = await verifyOtp(enteredOtp, refId);
      setloading(false);
      otpRef.current.value = "";
      setAadharData(res[0]);
      setisOtp(false);
    } catch (error) {
      setError(error.response.data.detail.message);
      otpRef.current.value = "";
      setloading(false);
    }
  };

  const handleImages = async () => {
    const res = await sendImagesToModel(uid, capturedImages);
    if (!res.message === "Success") {
      alert("Something went wrong uploading images");
      return;
    }
    navigate("/");
    closeModal();
  };

  return (
    <div className="register_container">
      {error && (
        <Alert
          description={error || "Some Error"}
          type="error"
          showIcon
          closable
          style={{ position: "absolute", zIndex: "999", top: "2px" }}
        />
      )}
      <div className="registration_wrapper">
        <div className="aadhar_container">
          <div className="heading">Registration</div>
          <div className="inputbox">
            <label htmlFor="aadhar">Aadhar No.</label>
            <input ref={aadharNoRef} type="number" id="aadhar" />
            <Button
              type="primary"
              onClick={handleAdhar}
              disabled={loading && aadharNoRef.current.value}
            >
              {loading && aadharNoRef.current.value ? "Fetching" : "Fetch"}
            </Button>
          </div>
          {isOtp && (
            <div className="verifyBox">
              <label htmlFor="VerifyOtp">Verify Otp</label>
              <input ref={otpRef} type="number" id="verifyOtp" />
              <Button
                type="primary"
                onClick={handleOtpVerification}
                disabled={loading && otpRef.current.value}
              >
                {loading && otpRef.current.value
                  ? "Verifying Otp..."
                  : "Verify"}
              </Button>
            </div>
          )}
        </div>
        <div className="form_container">
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
          >
            <Row>
              <Col span={16}>
                <Row gutter={16}>
                  <Col span={2}>
                    <Form.Item
                      label="Title"
                      name="title"
                      rules={[
                        { required: true, message: "Please enter your Title" },
                      ]}
                    >
                      <Select>
                        <Select.Option value="mr">Mr.</Select.Option>
                        <Select.Option value="ms">Ms.</Select.Option>
                        <Select.Option value="mrs">Mrs.</Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={4}>
                    <Form.Item label="Initial" name="initial">
                      <Input autoComplete="none" />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item
                      label="First Name"
                      name="firstname"
                      rules={[
                        {
                          required: true,
                          message: "Please enter your First Name",
                        },
                      ]}
                    >
                      <Input autoComplete="none" />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item label="Middle Name" name="middlename">
                      <Input autoComplete="none" />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item
                      label="Last Name"
                      name="lastname"
                      rules={[
                        {
                          required: true,
                          message: "Please enter your Last Name",
                        },
                      ]}
                    >
                      <Input autoComplete="none" />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={16}>
                  <Col span={6}>
                    <Form.Item
                      label="Father/Husband Name"
                      name="fathername"
                      rules={[
                        { required: true, message: "Please enter the name" },
                      ]}
                    >
                      <Input autoComplete="none" />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item
                      label="Registration Type"
                      name="registrationtype"
                      rules={[
                        {
                          required: true,
                          message: "Please enter the Registration Type",
                        },
                      ]}
                    >
                      <Select>
                        <Select.Option value="normal">Normal</Select.Option>
                        <Select.Option value="emergency">
                          Emergency
                        </Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={4}>
                    <Form.Item
                      label="Date Of Birth"
                      name="dob"
                      rules={[
                        {
                          required: true,
                          message: "Please enter your Date Of Birth",
                        },
                      ]}
                    >
                      <DatePicker format="DD-MM-YYYY" />
                    </Form.Item>
                  </Col>

                  <Col span={2}>
                    <Form.Item
                      label="Age"
                      name="age"
                      rules={[
                        { required: true, message: "Please enter your Age" },
                      ]}
                    >
                      <Input autoComplete="none" />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item
                      label="Years/Month"
                      name="yearsmonth"
                      initialValue="Years"
                      rules={[
                        {
                          required: true,
                          message: "Please Select Years/Months",
                        },
                      ]}
                    >
                      <Select disabled>
                        <Select.Option value="Years">Years</Select.Option>
                        <Select.Option value="Months">Months</Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={16}>
                  <Col span={6}>
                    <Form.Item label="Religion" name="religion">
                      <Select>
                        <Select.Option value="hindu">Hindu</Select.Option>
                        <Select.Option value="christian">
                          Christian
                        </Select.Option>
                        <Select.Option value="sikh">Sikh</Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item label="Cast" name="cast">
                      <Select>
                        <Select.Option value="madwadi">Madwadi</Select.Option>
                        <Select.Option value="catholic">Catholic</Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={4}>
                    <Form.Item label="Sex" name="sex">
                      <Select>
                        <Select.Option value="male">Male</Select.Option>
                        <Select.Option value="female">Female</Select.Option>
                        <Select.Option value="other">Other</Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={2}>
                    <Form.Item label="B-Group" name="bloodgroup">
                      <Select>
                        <Select.Option value="a+">A+</Select.Option>
                        <Select.Option value="a-">A-</Select.Option>
                        <Select.Option value="b+">B+</Select.Option>
                        <Select.Option value="b-">B-</Select.Option>
                        <Select.Option value="o+">O+</Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item label="Marital Status" name="maritalstatus">
                      <Select>
                        <Select.Option value="Married">Married</Select.Option>
                        <Select.Option value="Un-Married">
                          Un-Married
                        </Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={16}>
                  <Col span={6}>
                    <Form.Item label="Occupation" name="occupation">
                      <Select>
                        <Select.Option value="salaried">Salaried</Select.Option>
                        <Select.Option value="selfemployed">
                          Self Employed
                        </Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item label="Monthly Income (RS.)" name="income">
                      <Slider range min={1000} max={50000} />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item label="Patient Category" name="category">
                      <Select>
                        <Select.Option value="generalpatient">
                          General Patient
                        </Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item label="Nationality" name="nationality">
                      <Select>
                        <Select.Option value="indian">Indian</Select.Option>
                        <Select.Option value="american">American</Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={16}>
                  <Col span={24}>
                    <Form.Item label="Remarks" name="remarks">
                      <TextArea
                        style={{
                          height: 100,
                          marginBottom: 2,
                        }}
                        placeholder="Remarks"
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col span={8}>
                <div className="photo_container">
                  {(photo === "data:image/jpeg;base64,undefined" ||
                    undefined) && (
                    <img src={userImg} width={300} height={300} />
                  )}
                  {(photo !== "data:image/jpeg;base64,undefined" ||
                    undefined) && <img src={photo} width={300} height={300} />}
                </div>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={4}>
                <Form.Item label="House Name/Apt. No." name="housename">
                  <Input autoComplete="none" />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item label="Address" name="address">
                  <Input autoComplete="none" />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item label="Post Office/ Town" name="postoffice">
                  <Input autoComplete="none" />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item label="Country" name="country">
                  <Input autoComplete="none" />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item label="State" name="state">
                  <Input autoComplete="none" />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item label="City" name="city">
                  <Input autoComplete="none" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={4}>
                <Form.Item label="Pincode" name="pincode">
                  <Input autoComplete="none" />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item label="Phone" name="phone">
                  <Input autoComplete="none" />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item label="Office Phone" name="officephone">
                  <Input autoComplete="none" />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item label="Cell Phone" name="cellphone">
                  <Input autoComplete="none" />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item label="Email" name="email">
                  <Input autoComplete="none" />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>

      <Modal
        open={isModalVisible}
        onCancel={closeModal}
        footer={null}
        closable={false}
        title="Please look at the screen"
      >
        <Webcam style={{ width: "100%" }} audio={false} ref={webcamRef} />
        <Progress percent={progress} />
        {capturedImages.length === 15 && (
          <Button type="primary" onClick={handleImages}>
            Upload
          </Button>
        )}
      </Modal>
    </div>
  );
};

export default Register;
